import React from "react";

import { useRouter } from "next/router";

import { Input } from "antd";
import { debounce } from "lodash";

const DebouncedSearch = ({ onChange, defaultValue, setLoading, ...rest }: any) => {
  const router = useRouter();
  const { search } = router.query;

  const handleOnChange = debounce((val: string) => {
    if (val) {
      router.push({
        pathname: router?.pathname,
        query: {
          ...router?.query,
          search: val,
        },
      });
    } else {
      const obj = { ...router?.query };
      delete obj?.search;

      router.push({
        pathname: router?.pathname,
        query: obj,
      });
    }
  }, 500);

  return (
    <Input.Search
      size={"middle"}
      {...rest}
      defaultValue={defaultValue || search}
      onChange={(e) => {
        if (setLoading) {
          setLoading(true);
        }
        e.persist();

        onChange && onChange(e.target.value);
        handleOnChange(e.target.value);
      }}
    />
  );
};

export default DebouncedSearch;
